// src/features/live/panels/LiveNowPanel.tsx — right-rail "Live now" list.
// Mirrors src/features/videos/panels/ShortsPanel.tsx's rail-row shape.
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Panel, SectionLabel } from '@/ui';
import { GeneratedThumb } from '@/components/GeneratedThumb/GeneratedThumb';
import { ThumbBadge } from '@/components/GeneratedThumb/ThumbBadge';
import { formatViewers, LIVE_BADGE_BG } from '../meta';
import type { LiveChannel } from '@/core/models/live';

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Row = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
`;

const ThumbWrap = styled.div`
  position: relative;
  width: 64px;
  height: 44px;
  border-radius: ${({ theme }) => theme.radius.sm};
  overflow: hidden;
  flex-shrink: 0;
`;

const LiveTag = styled(ThumbBadge)`
  background: ${LIVE_BADGE_BG};
  font-weight: 700;
`;

const Title = styled.span`
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export interface LiveNowPanelProps {
  channels: LiveChannel[];
}

export function LiveNowPanel({ channels }: LiveNowPanelProps) {
  return (
    <Panel>
      <SectionLabel as="h2">Live now</SectionLabel>
      <List>
        {channels.map((c) => (
          <li key={c.id}>
            <Row to={`/live/${c.id}`} aria-label={`${c.title}, live, ${formatViewers(c.viewerCount)}`}>
              <ThumbWrap>
                <GeneratedThumb seedKey={c.id} fill live />
                <LiveTag $corner="bl" $compact>Live</LiveTag>
              </ThumbWrap>
              <Title>{c.title}</Title>
            </Row>
          </li>
        ))}
      </List>
    </Panel>
  );
}
